import i18n from 'shared/locale/i18n.js';

const scale = 100000;

export function formatFlightDuration(totalMinutes) {
    if (typeof totalMinutes !== 'number' || isNaN(totalMinutes)) {
        return '-';
    }
    const hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;
    if (minutes < 10) {
        minutes = `0${minutes}`;
    }
    return i18n.t('common:datetime.duration', { hours, minutes });
}

export function savedSearchNameFromRequest({
    requestedOriginCity,
    requestedDestinationCity,
    requestedOriginCity2,
    requestedDestinationCity2,
    requestedDepartureDate,
    requestedReturnDate,
}) {
    const destinationString =
        requestedOriginCity2 && requestedDestinationCity2
            ? `${requestedOriginCity}-${requestedDestinationCity}-${requestedOriginCity2}-${requestedDestinationCity2}`
            : `${requestedOriginCity}-${requestedDestinationCity}`;

    return i18n.t(`result:savedSearch.searchName`, {
        context: requestedReturnDate ? 'return' : 'single',
        locations: destinationString,
        departureDate: requestedDepartureDate,
        returnDate: requestedReturnDate,
    });
}

export function fromRealToLogValue(value) {
    return Math.round(Math.log(value) * scale);
}

export function fromLogToRealValue(position) {
    return Math.round(Math.exp(position / scale));
}
